
var authRedirectUrlActions = (function() {

    var _setLoginRedirectUrl = function(redirectUrl){
        return {
            type: 'SET_LOGIN_REDIRECT_URL',
            loginRedirectUrl: redirectUrl
        };
    }

    var _clearLoginRedirectUrl = function(){
        return {
            type: 'CLEAR_LOGIN_REDIRECT_URL'
        };
    }

    return {
        setLoginRedirectUrl: _setLoginRedirectUrl,
        clearLoginRedirectUrl: _clearLoginRedirectUrl
    }
})();

module.exports = authRedirectUrlActions;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-redirect-url.js